/* eslint-disable */
import React from 'react'
import http from '../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import jMoment from 'moment-jalaali'
import Page from '../Pagination/Pagination'
import {Button, Container, Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import HeaderTable from '../BaseComponent/HeaderTable'
import $ from 'jquery'
import {message} from 'antd'
import moment from 'moment'
import REPORT_DISPATCH from '../BaseComponent/REPORTDISPATCH'
import USER_MANAGE from '../BaseComponent/USERMANAGE'
import ExcelExport from '@progress/kendo-react-excel-export/dist/npm/ExcelExport'
import DeliveryPackPrint from '../BaseComponent/deliveryPackPrint'
import DeliveryPackComponent from '../BaseComponent/deliveryPackComponent'
import Pageing from '../Pagination/pageing'
import HeaderGrid from '../Pagination/HeaderGrid'
import Loader from '../loaders/loader'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import Select from 'react-select'
import {withRouter} from 'react-router-dom'
import queryParams from '../BaseComponent/queryString'
import Autocomplete from '../BaseComponent/autocomplete'
class Factors extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      Factors: [],
      pageOfItems: [],
      printInfo: [],
      lengthProducts: '',
      modal: false,
      urlSign: '',
      selectedDateFrom: moment(),
      selectedDateTo: moment(),
      Drivers: [],
      aggregation: {},
      pageNumber: 1,
      pageSize: 10,
      sortBy: 'registerDate_desc',
      providerArr: [],
      providers: [],
      multiProvider: [],
      tablePageNumber: 1,
      providerId: ''
    }
  }

  changeState(e) {
    let target = e.target
    let value = target.value

    this.setState({
      state: value
    })
  }
  getReport = (exportStatus) => {
    let filter = this.createFilter(exportStatus)
    let createQueryFilter = filter
    delete createQueryFilter.export
    this.props.history.push(`?${queryParams(createQueryFilter)}`)
    this.setState({
      loading: true
    })
    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}`, {
        params: filter
      })
      .then((response) => {
        if (response.data.error == null) {
          // alert(JSON.stringify(response.data))
          if (!exportStatus) {
            $('.showBaseTable,.print').fadeIn()

            this.setState({
              tablePageNumber: this.state.pageNumber,
              tablePageSize: this.state.pageSize,
              Factors: response.data.object.result,
              lengthProducts: response.data.object.countAll,
              countAll: response.data.object.countAll,
              loading: false
            })
          } else {
            this.setState(
              {
                printInfo: response.data.object.result,
                loading: false
              },
              () => {
                setTimeout(() => {
                  window.print()
                }, 2000)
              }
            )
          }
        } else {
          message.error(response.data.description)
          this.setState({
            loading: false
          })
        }
      })
      .catch((error) => {
        this.setState({
          loading: false
        })
        //alert(JSON.stringify(error))
      })
  }

  componentDidMount() {
    // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`,{

    // }).then((response)=>{
    //     if(response.data.error==null){

    //         var provider = response.data.object;
    //         for (let i = 0; i < provider.length; i++) {
    //             provider[i]['value'] = provider[i].providerId;
    //             provider[i]['label'] =provider[i].providerId +' - '+ provider[i].title;
    //         }

    //         this.setState({
    //             providers:response.data.object
    //         })
    //     }
    //     else{
    //         this.setState({
    //             providers:[]
    //         })
    //     }
    // })

    http
      .get(`${USER_MANAGE.USER_MANAGE_LIST_DRIVER}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          this.setState({
            Drivers: response.data.object
          })
        }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })

    $(function() {
      $('.filterBtn').on('click', function() {
        $('.filterComponent').slideToggle()
      })

      $('.cancelFilter').click(function() {
        $('.filterComponent').slideUp()
      })
    })

    sessionStorage.removeItem('params')

    sessionStorage.setItem('pageNumber', '1')
    sessionStorage.setItem('dropDownVal', '10')

    this.getReport(false)
  }

  onResultFetched(data) {
    this.setState({
      Factors: data
    })
  }

  changeDropDown(data) {
    this.setState({
      Factors: data,
      lengthProducts: sessionStorage.getItem('countAll')
    })
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  createFilter = (exportStatus) => {
    let invoiceNum = this.convertDigit(document.getElementById('invoiceNum').value)
    let invoiceId = this.convertDigit(document.getElementById('invoiceId').value)
    let buyerName = document.getElementById('buyerName').value
    let recipientName = document.getElementById('recipientName').value
    let isPaid = document.getElementById('isPaid').value
    let payOnDelivery = document.getElementById('payOnDelivery').value
    let driverId = document.getElementById('driverId').value
    let totalAmountMin = this.convertDigit(document.getElementById('totalAmountMin').value)
    let totalAmountMax = this.convertDigit(document.getElementById('totalAmountMax').value)
    let lastState = document.getElementById('lastState').value
    let paperInvoice = document.getElementById('paperInvoice').value
    const allParams = new URLSearchParams(this.props.location.search)
    const planId = allParams.get('planId')
    const planDate = allParams.get('planDate')

    let {providerId} = this.state

    let filter = {}
    filter.pageNumber = this.state.pageNumber
    filter.pageSize = this.state.pageSize
    filter.sortBy = this.state.sortBy
    filter.planId = planId
    filter.planDate = planDate
    filter.export = exportStatus
    if (providerId) {
      filter.providerIds = providerId
    }
    if (invoiceNum !== '') {
      filter.invoiceNum = invoiceNum
    }
    if (invoiceId !== '') {
      filter.invoiceId = invoiceId
    }
    if (buyerName !== '') {
      filter.buyerName = buyerName
    }
    if (lastState !== '') {
      filter.lastState = lastState
    }
    if (driverId !== '') {
      filter.driverId = driverId
    }
    if (recipientName !== '') {
      filter.recipientName = recipientName
    }
    if (isPaid !== '') {
      filter.paid = isPaid
    }
    if (payOnDelivery !== '') {
      filter.payOnDelivery = payOnDelivery
    }
    if (totalAmountMin !== '') {
      filter.totalAmountMin = totalAmountMin
    }
    if (totalAmountMax !== '') {
      filter.totalAmountMax = totalAmountMax
    }
    if (paperInvoice !== '') {
      if (paperInvoice == 1) {
        filter.paperInvoice = true
      } else {
        filter.paperInvoice = false
      }
    }
    return filter
  }

  filter() {
    this.setState({
      pageNumber: 1
    })
    setTimeout(() => {
      this.getReport(false)
      let paramsFilter = this.createFilter(true)
      localStorage.setItem('deliveryPackParams', queryParams(paramsFilter))
    }, 500)
  }

  exportExcel = () => {
    let params = queryParams(this.createFilter(true))

    http
      .get(`${REPORT_DISPATCH.REPORT_DISPATCH_DELIVERYPACK_MASTER}?${params}`, {})
      .then((response) => {
        // alert(JSON.stringify(response.data))
        if (response.data.error == null) {
          console.log(response.data)
          // $('.showBaseTable,.print').fadeIn();

          sessionStorage.setItem('countAll', response.data.object.countAll)
          this.setState({
            excelReport: response.data.object.result
          })
          let {excelReport} = this.state
          for (let i = 0; i < excelReport.length; i++) {
            excelReport[i]['planDate'] = jMoment(excelReport[i]['planDate']).format('jYY/jMM/jDD')
            excelReport[i]['bazeTahvil'] =
              excelReport[i]['planTimeFrom'].substr(0, 5) + ' - ' + excelReport[i]['planTimeTo'].substr(0, 5)

            if (excelReport[i].invoice['mobile'] == null) {
              excelReport[i].invoice['mobile'] = '-'
            } else {
              excelReport[i].invoice['mobile'] = excelReport[i].invoice['mobile'].replace(/\+98/g, '0')
            }

            if (excelReport[i].invoice['paid']) {
              excelReport[i].invoice['paid'] = 'پرداخت شده'
            } else {
              excelReport[i].invoice['paid'] = 'پرداخت نشده'
            }

            if (excelReport[i].invoice['payOnDelivery']) {
              excelReport[i].invoice['payOnDelivery'] = 'بله'
            } else {
              excelReport[i].invoice['payOnDelivery'] = 'خیر'
            }

            if (excelReport[i].driver == null) {
              excelReport[i].driver = ''
            } else {
              excelReport[i].driver = excelReport[i].driver['name']
            }
          }

          this._export.save(this.state.excelReport)
        } else {
          this.setState({
            excelReport: []
          })
        }
      })
      .catch((error) => {
        // alert(JSON.stringify(error))
      })

    // this._export.save(excelData)
  }

  getPrintInfo = () => {
    this.getReport(true)
  }

  exportPrint = () => {
    var css = '@page { size:A4 landscape;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.getPrintInfo()
  }

  getPageNumber = (pageNumber) => {
    this.setState({
      pageNumber
    })
  }

  getPageSize = (pageSize) => {
    this.setState({
      pageSize,
      pageNumber: 1
    })
  }

  getSort = (sortBy) => {
    this.setState({
      sortBy
    })
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.pageNumber !== this.state.pageNumber) {
      this.getReport(false)
    }
    if (prevState.pageSize !== this.state.pageSize) {
      this.getReport(false)
    }
    if (prevState.sortBy !== this.state.sortBy) {
      this.getReport(false)
    }
  }

  handleChangeProvider = (multiProvider) => {
    var providerArr = []
    this.setState({multiProvider})
    if (multiProvider.length == '0') {
      this.setState({
        providerArr: []
      })
    } else {
      for (let prop of multiProvider) {
        providerArr.push(prop.providerId)
        this.setState({
          providerArr: providerArr
        })
      }
    }
  }

  render() {
    let {urlSign} = this.state
    let {loading} = this.state
    const allParams = new URLSearchParams(this.props.location.search)
    const planDate = allParams.get('planDate')

    return (
      <div className="rtl printA4Page">
        <Loader show={loading} />

        <div className="excelSection">
          <ExcelExport
            dir="rtl"
            ref={(exporter) => {
              this._export = exporter
            }}
            fileName="گزارش پارت تحویل.xls"
          >
            <grid style={{height: '420px'}} data={this.state.excelReport}>
              <gridColumn
                key={'planDate'}
                field={'planDate'}
                title={'تاریخ تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'bazeTahvil'}
                field={'bazeTahvil'}
                title={'بازه تحویل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
              <gridColumn
                key={'invoiceId'}
                field={'invoice.invoiceId'}
                title={'شناسه فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'invoiceNum'}
                field={'invoice.invoiceNum'}
                title={'شماره فاکتور'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'buyerName'}
                field={'invoice.buyerName'}
                title={'نام خریدار'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'userCode'}
                field={'customer.userCode'}
                title={'کد مشتری'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'nationalId'}
                field={'customer.nationalId'}
                title={'کد ملی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'recipientName'}
                field={'invoice.recipientName'}
                title={'تحویل گیرنده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'mobile'}
                field={'invoice.mobile'}
                title={'موبایل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'paid'}
                field={'invoice.paid'}
                title={'وضعیت پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payOnDelivery'}
                field={'invoice.payOnDelivery'}
                title={'پرداخت در محل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'driver'}
                field={'driver'}
                title={'رساننده'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'payableAmount'}
                field={'totalInfo.payableAmount'}
                title={'قابل پرداخت'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'cash'}
                field={'payment.cash'}
                title={'پرداخت نقدی'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'card'}
                field={'payment.card'}
                title={'پرداخت کارتخوان'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />

              <gridColumn
                key={'prePaid'}
                field={'payment.prePaid'}
                title={'پرداخت از قبل'}
                width="100px"
                footerCellOptions={{wrap: true, textAlign: 'center'}}
              />
            </grid>
          </ExcelExport>
        </div>

        <DeliveryPackPrint
          printInfo={this.state.printInfo}
          rightSectionPrint={'در تاریخ : ' + jMoment(Number(this.convertDigit(planDate))).format('jYY/jM/jD')}
          centerSection={''}
        />

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>پارت تحویل رساننده</li>
          </ul>
          <div className="tableComponent">
            <div className="tableTools">
              <div className="tableOptionWrapp">
                <HeaderTable addUrl="" disablePageSize />
                <HeaderGrid getPageSize={this.getPageSize} createLink={''} enablePageSize />

                <Link
                  to={'/printBaskets?' + this.props.location.search}
                  class="printLink d-inline-block"
                  style={{marginTop: '10px'}}
                  target="_blank"
                >
                  <span>چاپ فاکتور</span>
                </Link>
                <Link
                  to={'/a4Print' + this.props.location.search}
                  class="printLink d-inline-block"
                  style={{marginTop: '10px'}}
                  target="_blank"
                >
                  <span className="d-inline-block" style={{marginTop: '-10px'}}>
                    چاپ فاکتور A4
                  </span>
                </Link>
                <Link
                  to={'/printLabel' + this.props.location.search}
                  class="printLink d-inline-block"
                  style={{marginTop: '10px'}}
                  target="_blank"
                >
                  <span>چاپ لیبیل</span>
                </Link>

                <button className="filterBtn">
                  <i className="fa fa-search" />
                </button>
                <button className={'printButton'} onClick={this.exportExcel}>
                  <i className="fas fa-file-excel" />
                </button>
                <button className="printButton" onClick={this.exportPrint}>
                  <i className="fas fa-print" />
                </button>
              </div>
            </div>
            <div className="filterComponent">
              <div className="filterInputs">
                <div className="formComponent">
                  <label>شناسه فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceId" name="invoiceId" />
                </div>

                <div className="formComponent">
                  <label>شماره فاکتور:</label>
                  <input type="text" className="form-control" id="invoiceNum" name="invoiceNum" />
                </div>

                <div className="formComponent">
                  <label>نام خریدار :</label>
                  <input type="text" className="form-control" id="buyerName" name="buyerName" />
                </div>

                <div className="formComponent">
                  <label>نام تحویل گیرنده :</label>
                  <input type="text" className="form-control" id="recipientName" name="recipientName" />
                </div>

                <div className="formComponent">
                  <label>وضعیت پرداخت :</label>
                  <select className="form-control" id="isPaid" name="isPaid">
                    <option value="">-------</option>
                    <option value={1}>پرداخت شده</option>
                    <option value={0}>پرداخت نشده</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>پرداخت در محل :</label>
                  <select className="form-control" id="payOnDelivery" name="payOnDelivery">
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>

                <div className="formComponent">
                  <label>رساننده:</label>
                  <select className="form-control" id="driverId" name="driverId">
                    <option value="">-----</option>
                    {this.state.Drivers.map((driver, index) => (
                      <option key={`driver${index}`} value={driver.personId}>
                        {driver.name}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="formComponent">
                  <label>مبلغ کل از :</label>
                  <input type="text" className="form-control" id="totalAmountMin" name="totalAmountMin" />
                </div>

                <div className="formComponent">
                  <label>مبلغ کل تا :</label>
                  <input type="text" className="form-control" id="totalAmountMax" name="totalAmountMax" />
                </div>

                <div className="formComponent">
                  <label>حالت:</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="lastState"
                    name="lastState"
                  >
                    <option value="">-------</option>
                    <option value="-100">کنسل</option>
                    <option value="-75">مرجوعی</option>
                    <option value="-50">بازگشتی</option>
                    <option value="100">تخصیص مجدد</option>
                    <option value="-1">تخصیص داده نشده</option>
                    <option value="1">فعال</option>
                    <option value="15">تحویل ناقص</option>
                    <option value="5">اول فعال</option>
                    <option value="10">شروع شده</option>
                    <option value="18">تسویه شده</option>
                  </select>
                </div>

                <div className="formComponent selectComponent">
                  <Autocomplete
                    label="تامین کننده"
                    api={`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`}
                    textField="title"
                    valueField="providerId"
                    id="provider"
                    value={this.state.providerId}
                    setValue={(providerId) => this.setState({providerId})}
                  />
                </div>

                {/* <div className="formComponent selectComponent">
                  <label>تامین کننده ها :</label>
                  <Select
                    value={this.state.multiProvider}
                    onChange={this.handleChangeProvider}
                    options={this.state.providers}
                    isMulti={true}
                    isClearable={true}
                    placeholder=""
                  />
                </div> */}
                <div className="formComponent">
                  <label>دارای رسید کاغذی</label>
                  <select
                    className="form-control"
                    onChange={this.changeState.bind(this)}
                    id="paperInvoice"
                    name="paperInvoice"
                  >
                    <option value="">-------</option>
                    <option value={1}>بله</option>
                    <option value={0}>خیر</option>
                  </select>
                </div>
              </div>
              <div className="filterOption">
                <button className="confirmFilter" onClick={this.filter.bind(this)}>
                  جست و جو
                </button>
              </div>
            </div>

            <DeliveryPackComponent
              deliveryPackData={this.state.Factors}
              pageNumber={this.state.tablePageNumber}
              pageSize={this.state.tablePageSize}
              getDeliverySort={this.getSort}
            />
            {this.state.Factors.length > 0 && (
              <div className="paginationWrapp">
                <Pageing
                  defaultCurrent={1}
                  getPage={this.getPageNumber}
                  pageSize={this.state.pageSize}
                  currentPage={this.state.pageNumber}
                  total={this.state.countAll}
                />
              </div>
            )}
          </div>

          <Modal isOpen={this.state.modal} toggle={this.toggle} size="sm">
            <ModalHeader toggle={this.toggle}>نمایش امضا</ModalHeader>
            <ModalBody>
              <div className="imageSign">
                <img src={urlSign} alt="" />
              </div>
            </ModalBody>
            <ModalFooter>
              <Button color="danger" onClick={this.handleCancel}>
                بستن
              </Button>
            </ModalFooter>
          </Modal>
        </div>
      </div>
    )
  }
}

export default withRouter(Factors)
